export function onRowClicked(grid, callback) {
	if (callback) {
		grid.wrapper.on("click", ".cw_grid_link", (e) => {
			const data = grid.dataItem($(e.target).closest('tr'));
			callback(data.toJSON());
		});
	}
}
